(ns pfo.common.component
  (:require [reagent.core :as reagent :refer [atom] :refer-macros [with-let]]
            #_:clj-kondo/ignore [taoensso.timbre :as timbre
                                 :refer [log trace debug info warn error fatal report logf
                                         tracef debugf infof warnf errorf fatalf reportf spy]]
            [applied-science.js-interop :as j]
            [dommy.core :as dommy :refer-macros [sel]]
            [clojure.string :as str]
            [pfo.flag :refer [enabled]]
            [lentes.core :as l]
            [pfo.util :as util :refer [reset-from-event handler]]
            [pfo.form :as form :refer [set-checked checked? option-value]]
            [pfo.widget.tabs :refer [tab header-tabs]]
            [pfo.widget.modal :refer [modal modal-window]]
            [pfo.state :as state]
            [pfo.api :as api :refer [process-error]]
            [pfo.download :as download]
            [pfo.auth.component :as auth-component]
            [pfo.auth.model :as auth-model]
            [pfo.widget.select :refer [nested-select default-select-sizer]]
            [promesa.core :as p]
            [pfo.label.component :as label-component]))

(defn content [component]
  [:div.content (when @state/sidebar-active {:class "sidebar-active"}) component])

(defn topbar [left-component right-component]
  [:div.topbar [:div.left left-component] [:div.right right-component]])

(defn topbar2 [left-component right-component simple?]
  [:header {:class (if simple? "c-header--simple" "c-header")} left-component right-component])

(defn toolbar [items]
  [:div ;;[:div.header (entity "&nbsp;")]
   [:div.value (into [:div.toolbar] items)]])

(defn toolbar-item [title active on-click]
  [:a.toolbar-item-link {:href "#" :on-click on-click} [:input.toolbar-check (set-checked active)] " " title])

(defn empty-page [] [:div])

(defn header-tab-wrapper [title tab-contents controls]
  [header-tabs nil (tab title nil nil tab-contents controls)])

(defn header-tab-wrapper-with-options [options title tab-contents controls]
  [header-tabs options (tab title nil nil tab-contents controls)])

;TODO deprecated
(defn standalone-form-redesign [content]
  [:div.standalone-form-redesign.redesign content])

(defn header [& {:keys [supertitle title category aside-title subtitles subsubtitle aside-subtitles controls simple? label review-button]}]

  (if simple?

    [:header.c-header--simple
     [:h2 title]]

    [:header.c-header
     [:main
      [:h2 supertitle]

      [:div.c-header__title
       (when (not-empty category) [:span.type-circle [:span category]]) [:h1 title]
       (map-indexed (fn [idx subtitle] [:p {:key idx} subtitle]) subtitles)
       subsubtitle
       (when label (apply label-component/label label))]]
     [:aside
      [:h4 {:class aside-title} aside-title]

      [:div.c-header__dates
       (map-indexed (fn [idx [k v]] (when v [:p {:key idx} [:span.key k] [:span.value v]])) aside-subtitles)]

      (when controls
        [:div.c-header__controls controls])

      (when review-button
        [:div.c-header__review-button review-button])]]))

(defn sidebar-main
  "use with conjuction with .o-main-aside container and .o-main-aside--main adjacent component"
  [& contents]
  [:aside.u-font-size--smaller.o-margin-elements--lg-vrtcl.o-main-aside__aside--small.sidebar

   (map-indexed (fn [index elem] (with-meta elem {:key index})) contents)])

(defn sidebar
  [& contents]
  (sidebar-main
   (into [:aside.o-media--small.u-shadow--around] contents)))

(defn sidebar-rounded
  [& contents]
  (sidebar-main
   (into [:aside.c-sidebar-rounded] contents)))

(defn active-filter-item [options active-atom]
  [:div.o-media--1x05.u-shadow--bottom
   [:ul [:li "Active status"]]
   [:select {:on-change (or (:on-change-cb options) (fn [ev] ((reset-from-event active-atom) ev)))}
    [:option (option-value @active-atom "active") "Active"]
    [:option (option-value @active-atom "inactive") "Inactive"]
    [:option (option-value @active-atom "all") "All"]]])

(defn show-confirmation-modal [options]
  (reset! state/confirmation-modal (merge options {:enabled true})))

(defn hide-confirmation-modal []
  (reset! state/confirmation-modal {:enabled false}))

(defn show-action-modal [options]
  (reset! state/action-modal (merge options {:enabled true})))

(defn hide-action-modal []
  (reset! state/action-modal {:enabled false}))

(defn show-controled-confirmation-modal [options]
  (reset! state/controled-confirmation-modal (merge options {:enabled true})))

(defn hide-controled-confirmation-modal []
  (reset! state/controled-confirmation-modal {:enabled false}))

(defn confirmation-modal []
  (let [{:keys [title text ok-cb]} @state/confirmation-modal]
    [modal
     [:div
      [:h3 title]
      [:p.u-margin-top.u-margin-bottom text]
      [:footer.o-space-between
       [:button
        {:type     :button
         :on-click (handler #(hide-confirmation-modal))}
        "Cancel"]
       [:button
        {:type     :submit
         :on-click (handler
                    (fn []
                      (hide-confirmation-modal)
                      (ok-cb)))}
        "OK"]]]
     state/confirmation-modal]))

(defn action-modal []
  (let [{:keys [title content actions close-cb]} @state/action-modal]
    [modal
     [:div
      [:h3.error title]
      content
      [:footer.o-space-between
       [:button
        {:type     :button
         :on-click (handler (fn []
                              (some-> close-cb (apply []))
                              (hide-action-modal)))}
        "Cancel"]
       [:div.u-flex__element-to-right.o-margin-elements--xs
        (for [action actions
              :let   [action-cb (:action-cb action)]]
          (doall
           [:button
            {:type     :submit
             :key (:text action)
             :on-click (handler
                        (fn []
                          (hide-action-modal)
                          (action-cb)))}
            (:text action)]))]]]
     state/action-modal]))

(defn controled-confirmation-modal []
  (fn []
    (let [{:keys [title text ok-cb close-cb control-phrase required-phrase errors]} @state/controled-confirmation-modal]
      [modal
       [:div
        [:h3 title]
        [:p.u-margin-top.u-margin-bottom text]
        (when control-phrase
          [:form.c-form--edit
           [:fieldset
            [:dl
             [:dt "Type " [:em (or required-phrase "delete")] " to confirm"]
             [:dd
              [:input.u-width--full
               {:style     {:font-style :italic}
                :type      "text"
                :value     @control-phrase
                :on-change (reset-from-event control-phrase)}]
              (when errors [:span.error (:control_phrase @errors "")])]]]
           [:footer.o-space-between
            [:button
             {:type     :button
              :on-click (handler (fn []
                                   (hide-controled-confirmation-modal)
                                   (some-> close-cb (apply []))))}
             "Cancel"]
            [:button
             {:type     :submit
              :on-click (handler ok-cb)}
             "OK"]]])]
       state/controled-confirmation-modal])))

(defn modals []
  [:div
   (doall
     ;; TODO: implement order to allow predictable layering
     (for [[id mod] @state/modals]
       ^{:key id}
       [modal-window (:component mod) {:close-cb (fn []
                                                   (swap! state/modals update id :enabled false)
                                                   (some-> mod :options :close-cb (apply [])))
                                       :close-disable (-> mod :options :close-disable)
                                       :is-enabled-fn #(:enabled mod)
                                       :lower-layer (-> mod :options :lower-layer)
                                       :modal-class (-> mod :options :modal-class)
                                       :modal-style (-> mod :options :modal-style)
                                       :scroll-top (-> mod :options :scroll-top)
                                       :x (-> mod :options :x)
                                       :y (-> mod :options :y)}]))])

(defn show-modal [id component options]
  (swap! state/modals assoc id
         {:enabled true
          :component component
          :options options}))

(defn hide-modal [id]
  (swap! state/modals assoc id
         {:enabled false}))

(defn  mobile? []
  (let [user-agent (.-userAgent js/navigator)
        is-touch (or (.-ontouchstart js/window)
                     (>= (.-maxTouchPoints js/navigator) 1))
        is-mobile-agent (re-find #"Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini" user-agent)]
    (and is-touch is-mobile-agent)))

(defn filter-exclude
  ([{:keys [disabled]} value-atom]
   (filter-exclude {:disabled disabled} value-atom nil))
  ([{:keys [disabled]} value-atom callback]
   (when (enabled "filter-enhancements")
     [:span
      [:label.u-vertical-align--middle.u-text-uppercase
       (when disabled
         {:class :u-disabled})
       [:input (set-checked @value-atom
                            (merge
                             {:on-change (fn [ev]
                                           (let [new-val (checked? ev)]
                                             (reset! value-atom new-val)
                                             (when callback
                                               (callback))))}
                             (when disabled
                               {:disabled :disabled})))]
       "Exclude"]])))

(defn date-filter [options quarters filter-period]
  (when (not-empty @quarters)
    (let [year-name (fn [year] (if (= "0" (str year)) "Undated" year))]
      @quarters
      [nested-select
       filter-period
       (merge
        {:initial-id @filter-period
         :label "Period"
         :children-loader (fn [item-id]
                            (p/promise
                             (if item-id
                               (mapv (fn [quarter] {:id (str item-id "-" (:quarter quarter))
                                                    :name (str "Q" (:quarter quarter))})
                                     (filterv (fn [quarter] (and (= item-id (str (:year quarter)))
                                                                 (not= 0 (:quarter quarter))))
                                              @quarters))
                               (distinct (mapv (fn [quarter] {:id (:year quarter)
                                                              :name (year-name (:year quarter))})
                                               @quarters)))))
         :ancestors-loader (fn [item-id]
                             (p/promise
                              (if (and (string? item-id) (some #{"-"} item-id))
                                (let [[year quarter] (util/split-string item-id "-")]
                                  [{:id year :name (year-name year)} {:id item-id :name (str "Q" quarter)}])
                                [{:id item-id :name (year-name item-id)}])))
         :sizer default-select-sizer
         :clear true
         :green-box true
         :mobile (mobile?)}
        options)])))

(defn- period-getter [period]
  (let [[year month day] (map util/somestr-to-int (filter not-empty (str/split (or period "") #"-")))]
    {:year year :month month :day day}))

(defn- period-setter [state value]
  (let [current-period (period-getter state)
        updated (value current-period)]
    (str/join "-" (filterv identity (mapv (fn [key] (not-empty (str (updated key)))) [:year :month :day])))))

(def period-lens (l/lens period-getter period-setter))

(defn filter-header [options label]
  [:h3.u-padding-top.u-border-top--light-green.u-cursor--pointer.u-flex
   [:span {:on-click (:on-click options)} label]
   (:header-extra options)])

(defn date-day-filter [options ranges filter-period]
  (with-let [period (l/derive period-lens filter-period)
             *year (l/derive (l/key :year) period)
             *month (l/derive (l/key :month) period)
             *day (l/derive (l/key :day) period)
             month-names (into {} form/month-choices)
             clear-fn (util/handler #(reset! period {}))]
    [:div.o-collapsable {:class (when (:collapsed options) "is-collapsed")}
     [filter-header (merge options {:on-click clear-fn}) (:label options)]
     [:p.u-font-size--smaller.u-flex.u-flex--justify-content-space-between
      (when (:clear options)
        [:a {:href "#"
             :on-click clear-fn} "CLEAR"])
      (:extra-option options)]
     [:select.u-margin-right--xs {:on-change (fn [ev]
                                               (reset! period {:year (util/event-value ev) :month nil :day nil}))
                                  :value (or @*year "")}
      [:option {:value ""} "-- Year --"]
      (doall
       (for [year (sort (keys ranges))]
         [:option {:key year :value year} year]))]
     (when @*year
       [:select.u-margin-right--xs {:on-change (fn [ev]
                                                 (swap! period merge {:month (util/event-value ev) :day nil}))
                                    :value (or @*month "")}
        [:option {:value ""} "-- Month --"]
        (doall
         (for [month (sort (keys (ranges @*year)))]
           [:option {:key month :value month} (month-names month)]))])
     (when @*month
       [:select.u-margin-right--xs {:on-change (util/reset-from-event *day)
                                    :value (or @*day "")}
        [:option {:value ""} "-- Day --"]
        (doall
         (for [day (get-in ranges [@*year @*month])]
           [:option {:key day :value day} day]))])]))

(defn trigger-download [dl-link-el ajax-url ajax-options errors-atom]
  (->> (api/ajaxp ajax-url (merge ajax-options {:response-with-headers true}))
       (p/map (fn [{:keys [body headers]}]
                (let [body-str (if (string? body) body (.stringify js/JSON (clj->js body) nil 2))
                      obj-url  (.createObjectURL (.-URL js/window) (js/Blob. #js [body-str]))]
                  (when @dl-link-el
                    (aset @dl-link-el "href" obj-url)
                    (aset @dl-link-el "download" (second (re-find #"filename=\"?([^\"]+)\"?" (headers "content-disposition"))))
                    (.click @dl-link-el)
                    (.revokeObjectURL (.-URL js/window) obj-url)))))
       (process-error errors-atom)))

(defn download-button [{:keys [ajax-url
                               ajax-options
                               component]} label]
  (with-let [dl-link-el (atom nil)]
    [:div {:style {:display :inline-block}}
     [(or component :button) {:type (when-not component :button)
                              :on-click (util/handler
                                          (fn []
                                            (->>
                                              (api/ajaxp ajax-url (merge ajax-options {:response-with-headers true}))
                                              (p/map (fn [{:keys [body headers]}]
                                                       (let [obj-url (.createObjectURL (.-URL js/window) (js/Blob. (clj->js [body])))]
                                                         (when @dl-link-el
                                                           (aset @dl-link-el "href" obj-url)
                                                           (aset @dl-link-el "download" (second (re-find #"filename=\"?([^\"]+)\"?" (headers "content-disposition"))))
                                                           (.click @dl-link-el)))))
                                              (process-error))))} label]
     [:a {:style {:display :none} :ref (fn [el] (when el (reset! dl-link-el el)))} ""]]))

(defn pdf-download-button [{:keys [ajax-url
                                   temp-url-ajax-url
                                   filename
                                   component
                                   open-new-tab]} label]
  (letfn [(resolve-filename [resp]
            (or filename (download/filename-from-response resp "download.pdf")))
          (open-via-temp-url []
            (-> (js/fetch (api/api-url temp-url-ajax-url)
                          (clj->js {:headers (api/auth-headers)}))
                (.then (fn [resp]
                         (if (.-ok resp)
                           (.json resp)
                           (js/Promise.reject {:status (.-status resp)}))))
                (.then (fn [data] (.open js/window (.-url data) "_blank")))))
          (trigger-download [blob resp]
            (download/save-blob-as-file blob (resolve-filename resp) "application/pdf"))]
    [(or component :button) {:on-click (util/handler
                                         (fn []
                                           (let [done #(swap! state/loading-count (fn [c] (if (pos? c) (dec c) 0)))]
                                             (if (and open-new-tab temp-url-ajax-url)
                                               (-> (open-via-temp-url)
                                                   (.catch (fn [err] (api/handle-error-response nil err nil))))
                                               (do
                                                 (swap! state/loading-count inc)
                                                 (-> (js/fetch (api/api-url ajax-url)
                                                               (clj->js {:headers (api/auth-headers)}))
                                                     (.then (fn [resp]
                                                              (if (.-ok resp)
                                                                (.then (.blob resp) (fn [blob] [blob resp]))
                                                                (js/Promise.reject {:status (.-status resp)}))))
                                                     (.then (fn [[blob resp]]
                                                              (done)
                                                              (trigger-download blob resp)))
                                                     (.catch (fn [err]
                                                               (done)
                                                               (api/handle-error-response nil err nil)))))))))} label]))

(defn to-vec-ids [str-ids]
  (vec (map #(js/parseInt %) (str/split str-ids #","))))

(defn chosen-options [ids data]
  [:span.u-font-size--smaller.u-color--secondary
   (str/join ", " (set (map :name (filter #(some #{(:id %)} ids) data))))])

(defn multi-mobile-filter [options objects filter-atom]
  [:select {:multiple true
            :on-change (fn [ev]
                         (let [selected-options (->> (.-options (.-target ev))
                                                     (filter #(.-selected %))
                                                     (map (fn [selected-option] 
                                                            (if (:merged-objects options)
                                                              (to-vec-ids (.-value selected-option))
                                                              (js/parseInt (.-value selected-option)))))
                                                     (set))]
                           (reset! filter-atom selected-options)
                           (when (:reset-value-atoms options)
                             (doseq [object objects]
                                 (reset! (:value-atom object) (contains? @filter-atom (:id object)))))))}
   (doall
    (for [object objects]
      [:option {:value (:id object)
                :key (:id object)
                :selected (contains? @filter-atom (:id object))} (if (:format-name-fn options) 
                                                                   ((:format-name-fn options) object) 
                                                                   (:name object))]))])

(defn user-filter [options users filter-assigned-users label]
  (when (not-empty @users)
    (let [clear-fn (util/handler #(reset! filter-assigned-users #{}))]
      [:div
       [:div.filter-item.user-filter.o-collapsable {:class (when (:collapsed options) "is-collapsed")}
        [filter-header (merge options {:on-click clear-fn}) (or label "Assigned User")]
        [chosen-options @filter-assigned-users (map #(assoc % :name (auth-model/get-full-name %)) @users)]
        [:span.u-font-size--smaller.u-flex.u-flex--justify-content-space-between
         (when (:clear options)
           [:a {:href "#"
                :class (when (not (seq @filter-assigned-users)) :u-disable)
                :on-click clear-fn} "CLEAR"])
         (:extra-option options)]]
       [:div.o-collapsable.u-border--green-rounded {:class (when (:collapsed options) "is-collapsed__partial")}
        (if (mobile?)
          (multi-mobile-filter {:format-name-fn auth-model/get-full-name} @users filter-assigned-users)
          (auth-component/user-chooser-multi @users filter-assigned-users))]])))

(defn category-filter [options categories filter-categories]
  (when (not-empty @categories)
    (let [merged-categories (util/merge-objects-by-name @categories)
          clear-fn (util/handler #(reset! filter-categories #{}))]
      [:div
       [:div.filter-item.o-collapsable {:class (when (:collapsed options) "is-collapsed")}
        [filter-header (merge options {:on-click clear-fn}) "Category"]
        [chosen-options @filter-categories merged-categories]
        [:span.u-font-size--smaller.u-flex.u-flex--justify-content-space-between
         (when (:clear options)
           [:a {:href "#"
                :class (when (not (seq @filter-categories)) :u-disable)
                :on-click clear-fn} "CLEAR"])
         (:extra-option options)]]
       [:div.o-collapsable.u-border--green-rounded  {:class (when (:collapsed options) "is-collapsed__partial")}
        (if (mobile?)
          (multi-mobile-filter {:merged-objects true} merged-categories filter-categories)
          [:ul
           (doall
            (for [category merged-categories]
              (let [category-id (:id category)]
                [:li {:key category}
                 [:label
                  [:input (set-checked
                           (contains? @filter-categories category-id)
                           {:on-click (fn [ev]
                                        (let [selected (-> ev .-target .-checked)]
                                          (if selected
                                            (swap! filter-categories conj category-id)
                                            (swap! filter-categories disj category-id))))})]
                  (:name category)]])))])]])))


(defn collection-type-filter [options collection-types filter-collection-types]
  (when (not-empty @collection-types)
    (let [merged-collection-types (util/merge-objects (fn [coltype] (str (get-in coltype [:asset_type :name]) ": " (:name coltype))) @collection-types)
          clear-fn (util/handler #(reset! filter-collection-types #{}))]
      [:div
       [:div.filter-item.o-collapsable {:class (when (:collapsed options) "is-collapsed")}
        [filter-header (merge options {:on-click clear-fn}) "Collection Type"]
        [chosen-options @filter-collection-types merged-collection-types]
        [:span.u-font-size--smaller.u-flex.u-flex--justify-content-space-between
         (when (:clear options)
           [:a {:href "#"
                :class (when (not (seq @filter-collection-types)) :u-disable)
                :on-click clear-fn} "CLEAR"])
         (:extra-option options)]]
       [:div.o-collapsable.u-border--green-rounded  {:class (when (:collapsed options) "is-collapsed__partial")}
        (if (mobile?)
          (multi-mobile-filter {:merged-objects true} merged-collection-types filter-collection-types)
          [:ul
           (doall
            (for [coltype merged-collection-types]
              (let [coltype-id (:id coltype)]
                [:li {:key coltype}
                 [:label
                  [:input (set-checked
                           (contains? @filter-collection-types coltype-id)
                           {:on-click (fn [ev]
                                        (let [selected (-> ev .-target .-checked)]
                                          (if selected
                                            (swap! filter-collection-types conj coltype-id)
                                            (swap! filter-collection-types disj coltype-id))))})]
                  (:name coltype)]])))])]])))

(defn disable-exclude-on-unselect! [*filter-params [value-key exclude-key]]
  (add-watch (l/derive (l/key value-key) *filter-params)
             (keyword (str "reset-" exclude-key))
             (fn [_ _ old-state new-state]
               (when (and (not= old-state new-state)
                          (not (util/pytrue? new-state)))
                 (swap! *filter-params assoc exclude-key false)))))

(defn filter-top [filter-show clear-all-fn toggle-collapsed-all collapsed-all?]
  [:div
   [:div.o-space-between.u-margin-bottom
    [:h1 "APPLY FILTERS"]
    [:h1.u-color--secondary [:a {:href "#"
                                 :on-click (util/handler (fn [_]
                                                           (reset! filter-show false)))} "X"]]]
   [:div.o-space-between.u-margin-bottom.u-font-size--smaller.o-collapsable {:class (when @collapsed-all? "is-collapsed")}
    [:a {:href "#"
         :on-click (util/handler (fn [_]
                                   (clear-all-fn)))} "CLEAR ALL"]
    (when-not (mobile?)
      [:span.u-vertical-align--middle
       [:a
        {:href "#"
         :on-click (util/handler (fn [_]
                                   (swap! collapsed-all? not)
                                   (toggle-collapsed-all @collapsed-all?)))} (if @collapsed-all? "EXPAND ALL" "COLLAPSE ALL")]
       [:span.o-collapsable__expander]])]])

(defn rule-filter-multi [rules filter-rules]
  [:ul.u-border--green-rounded
   (doall
    (for [rule rules]
      (let [rule-id (:id rule)]
        [:li {:key rule-id}
         [:label
          [:input (set-checked
                   (contains? @filter-rules rule-id)
                   {:on-click (fn [ev]
                                (let [selected (-> ev .-target .-checked)]
                                  (if selected
                                    (swap! filter-rules conj rule-id)
                                    (swap! filter-rules disj rule-id))))})]
          (:name rule)]])))])

(defn rule-filter [options rules filter-rules]
  (let [clear-fn (util/handler #(reset! filter-rules #{}))]
    (when (not-empty @rules)
      [:div.filter-item.o-collapsable {:class (when (:collapsed options) "is-collapsed")}
       [:h3.u-padding-top.u-border-top--light-green.u-cursor--pointer.u-flex
        [:span {:on-click clear-fn} "Rule"]
        (:header-extra options)]
       [chosen-options @filter-rules @rules]
       [:p.u-font-size--smaller.u-flex.u-flex--justify-content-space-between
        (when (:clear options)
          [:a {:href "#"
               :class (when (not (seq @filter-rules)) :u-disable)
               :on-click clear-fn} "CLEAR"])
        (:extra-option options)]
       (if (mobile?)
         [:div.u-border--green-rounded (multi-mobile-filter nil @rules filter-rules)]
         (rule-filter-multi @rules filter-rules))])))

(defn adjust-checkboxes [container-el el]
  (when (and el container-el)
    (let [cwidth (.-clientWidth container-el)
          checkboxes (sel el :label.filter-checkbox)
          _ (doseq [checkbox checkboxes]
              (dommy/remove-class! checkbox "u-border-right--light-green")
              (j/assoc-in! checkbox [.-style .-width] ""))
          _ (doseq [br (sel el :br)]
              (dommy/remove! br))
          max-width (apply max (map #(.-clientWidth %) checkboxes))
          max-padding-right (js/parseFloat (apply max (map (fn [chk] (j/get (.getComputedStyle js/window chk) :paddingRight)) checkboxes)))
          new-width (* 1.00 (+ max-width max-padding-right))
          _ (doseq [checkbox checkboxes]
              (j/assoc-in! checkbox [.-style .-width] (str new-width "px")))
          num-columns (quot cwidth (int (* 1.1 new-width)))
          num-checkboxes (count checkboxes)]
      (debug "adjust checkboxes max item width, new width with padding" max-width new-width)
      (debug "adjust checkboxes container width" cwidth)
      (debug "adjust checkboxes num columns" num-columns)
      (doseq [[index checkbox] (map-indexed vector checkboxes)]
        (if (= num-columns (inc (mod index num-columns)))
          (dommy/insert-after! (dommy/create-element "br") checkbox )
          (when-not (= (inc index) num-checkboxes)(dommy/add-class! checkbox "u-border-right--light-green")))))))

(defn disable [component disabled message]
  [:span (merge {:class (when disabled :u-disable)}
           (when (and disabled message)
             {:title message}))
   component])

(def ^:private notice-banner-icons
  {:error       "/static/img/icons/review-alerttriangle.svg"
   :warning     "/static/img/icons/review-alerttriangle.svg"
   :success     nil
   :information nil})

(defn notice-banner
  "Generic notice/alert banner.
     :theme       — :error :warning :success :information
     :title       — (optional) bold headline
     :description — body text
     :link-text   — (optional) link label shown on the right
     :link-href   — (optional) href for the link
     :link-target — (optional) anchor target, defaults to _self
     :action-text — (optional) button label shown on the right
     :on-action   — (optional) callback fn for the action button"
  [{:keys [theme title description link-text link-href link-target action-text on-action]}]
  [:div.notice-banner {:class (str "notice-banner--" (name theme))}
   (when-let [icon (get notice-banner-icons theme)]
     [:img.notice-banner__icon {:src icon :alt ""}])
   [:div.notice-banner__body
    (when title [:strong.notice-banner__title title])
    [:span.notice-banner__description description]]
   (when link-text
     [:a.notice-banner__link (cond-> {:href link-href :target (or link-target "_self")}
                               (= link-target "_blank") (assoc :rel "noopener noreferrer"))
      link-text])
   (when (and action-text on-action)
     [:a.notice-banner__action {:href "#" :on-click (fn [e] (.preventDefault e) (on-action))} action-text])])
